import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import BaseCard from "../baseCard";
import MaterialTable from "material-table";
import {useQuery} from "@apollo/react-hooks";
import {GET_ACTIVITIES} from "../../../database/queries/activityQueries";
import tableIcons from "../../../constants/tableIcons";
import Moment from "react-moment";
import CalendarStrings from "../../../constants/calendarStrings";
import {AutoSizer} from 'react-virtualized';
import {notify} from "../../../utils/notify";
import {Link} from "react-router-dom";

const useStyles = makeStyles({
    root: {},
});

const ActivitiesCard = props => {
    const classes = useStyles();
    const [activities, setActivities] = useState([]);

    const {loading, error: getActivitiesError, data, refetch} = useQuery(GET_ACTIVITIES, {
        variables: {
            orderList: ['updatedAt DESC']
        },
    });

    const columns = [
        {
            title: 'Activity',
            width: '25%',
            render: r => {
                return (
                    <Link to={`/activities/${r.shareCategoryType}/${r.shareCategoryId}/${r.activityId}`}>
                        {r.activityName}
                    </Link>
                );
            },
            headerStyle: {padding: 6},
            cellStyle: {padding: 6, width: '30%'}
        },
        {
            title: 'Type',
            width: '15%',
            field: 'activityType',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6, width: '15%'}
        },
        {
            title: 'Status',
            width: '15%',
            field: 'activityStatus',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6, width: '15%'}
        },
        {
            title: 'Data',
            width: '15%',
            field: 'activityData',
            headerStyle: {padding: 6},
            cellStyle: {padding: 6, width: '15%'}
        },
        {
            title: 'Started',
            width: '15%',
            render: r => <Moment calendar={CalendarStrings}>{r.startedAt}</Moment>,
            headerStyle: {padding: 6},
            cellStyle: {padding: 6, width: '10%'}
        },
        {
            title: 'Ended',
            width: '15%',
            render: r => <Moment calendar={CalendarStrings}>{r.endedAt}</Moment>,
            headerStyle: {padding: 6},
            cellStyle: {padding: 6, width: '10%'}
        },
    ];

    useEffect(() => {
        if (getActivitiesError) notify('getActivitiesError', 'error', getActivitiesError.message);
    }, [getActivitiesError]);

    useEffect(() => {
        refetch();
    }, [refetch]);

    useEffect(() => {
        let myActivities = [];
        if (data && data.activities) {
            for (let a = 0; a < data.activities.length; a++) {
                const activity = data.activities[a];
                let myActivity = {...activity};
                if (myActivity.account) {
                    myActivity.parentType = 'account';
                    myActivity.parentId = myActivity.account.accountId;
                    myActivity.parentLink = '/accounts/' + myActivity.parentId;
                    myActivity.parentName = myActivity.account.accountName;
                } else if (myActivity.contact) {
                    myActivity.parentType = 'contact';
                    myActivity.parentId = myActivity.contact.contactId;
                    myActivity.parentLink = '/contacts/' + myActivity.parentId;
                    myActivity.parentName = myActivity.contact.firstName + ' ' + myActivity.contactlastName;
                } else if (myActivity.project) {
                    myActivity.parentType = 'project';
                    myActivity.parentId = myActivity.project.projectId;
                    myActivity.parentLink = '/projects/' + myActivity.projectId;
                    myActivity.parentName = myActivity.project.projectName;
                }
                myActivities.push(myActivity);
            }
            setActivities(myActivities);
        }
    }, [data]);

    if (loading) return <p>Loading ...</p>;
    if (getActivitiesError) return `Error! ${getActivitiesError.message}`;

    return (
        <AutoSizer>
            {({height, width}) => {
                const tableOptions = {
                    maxBodyHeight: height - 60,
                    padding: 'dense',
                    header: true,
                    paging: false,
                    showTitle: false,
                    search: false,
                    toolbar: false,
                    actionsColumnIndex: -1
                };
                return (
                    <BaseCard title={"Recent Activities"} height={height} width={width}>
                        <div className={classes.root}>
                            {activities && (
                                <MaterialTable
                                    icons={tableIcons}
                                    columns={columns}
                                    data={activities}
                                    options={tableOptions}
                                />
                            )}
                        </div>
                    </BaseCard>
                );
            }}
        </AutoSizer>
    );
};

export default ActivitiesCard
